module.exports = __webpack_public_path__ + "static/img/6945_phase_function_Paper_PointsHejduk_Prediction.3662e92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6945_phase_function_Paper_PointsHejduk_Prediction.png
// module id = MFV3
// module chunks = 0